import type { MultipleChoiceOption } from '~/src/entities/project';

export const MAX_LABEL_LENGTH = 45;

export const truncateLabel = (label: string) => {
  if (label.length <= MAX_LABEL_LENGTH) return label;
  return `${label.slice(0, MAX_LABEL_LENGTH - 1)}…`;
};

export type MultipleChoiceOptionWithPicklistMeta = MultipleChoiceOption & {
  isAppendedPicklist?: boolean;
};

export const appendPicklistOptions = (
  options: MultipleChoiceOptionWithPicklistMeta[],
  picklistOptions: Record<string, string> | undefined,
) => {
  if (!picklistOptions) return options;

  const optionsToAppend: MultipleChoiceOptionWithPicklistMeta[] = Object.values(
    picklistOptions,
  ).map((o) => ({
    option: truncateLabel(o),
    value: o,
    formatted: false,
    isAppendedPicklist: true,
  }));

  if (!optionsToAppend.length) return options;
  return [...options, ...optionsToAppend];
};
